export default {
  state: () => ({
    hasUnread: false,
    messages: [],
    messageThread: [],
    newMessage: null,
    newSignup: null,
    messageListeners: [],
    activeThread: null,
    participants: [],
    participantConsent: {},
    canSend: false,
    skip: 0
  })
}



// WEBPACK FOOTER //
// ./src/app/store/messaging/config.js